import { TimelineRow } from '../timeline-row/timeline-row.component';
import { TimelineRowPlaceholder } from '../timeline-row/timeline-row.placeholder';
import { TimelineEventProps } from '../timeline.types';
import { useTimelineRowsStyles } from './timeline-rows.styles';

export function TimelineRows({ events, isLoading }: { events: TimelineEventProps[]; isLoading: boolean }) {
  const classes = useTimelineRowsStyles();
  return isLoading ? (
    <div className={classes.rows}>
      {Array(4)
        .fill('')
        .map((_, index) => (
          <TimelineRowPlaceholder key={index} />
        ))}
    </div>
  ) : (
    <div className={classes.rows}>
      {events.map((event, index) => (
        <TimelineRow key={index} {...event} />
      ))}
    </div>
  );
}
